<template>
  <div>
    <dte-full-page-banner-sheet
      v-if="showFullPageBanner"
      ref="bannerPage"
      :document-data="documentData"
      layout="standard"
      :page-number="1"
      :total-pages="totalPageCount"
    />
    <article
      v-for="page in pages"
      :key="`standard-${displayPageNumber(page.number)}`"
      ref="pages"
      class="dte-sheet dte-sheet--standard"
    >
      <dte-standard-header-section
        v-if="page.isFirst"
        :document-data="documentData"
      />

      <div v-if="page.showReceiver" class="dte-standard-gap"></div>
      <dte-standard-recipient-section
        v-if="page.showReceiver"
        :document-data="documentData"
      />

      <div v-if="page.showThirdPartySale" class="dte-standard-gap"></div>
      <dte-standard-data-table-section
        v-if="page.showThirdPartySale"
        title="VENTA POR CUENTA DE TERCEROS"
        :document-data="documentData"
        :headers="['NIT', 'Nombre, denominacion o razon social']"
        :rows="[[documentData.thirdPartySale.nit, documentData.thirdPartySale.name]]"
      />

      <div v-if="page.showRelated" class="dte-standard-gap"></div>
      <dte-standard-data-table-section
        v-if="page.showRelated"
        title="DOCUMENTOS RELACIONADOS"
        :document-data="documentData"
        :headers="['Tipo de Documento', 'N de Documento', 'Fecha de Documento']"
        :rows="relatedRows"
      />

      <div v-if="page.showAssociated" class="dte-standard-gap"></div>
      <dte-standard-data-table-section
        v-if="page.showAssociated"
        title="DOCUMENTOS RELACIONADOS"
        :document-data="documentData"
        :headers="['Documento Asociado', 'N Documento Asociado', 'Descripcion']"
        :rows="associatedRows"
      />

      <div class="dte-standard-gap"></div>
      <dte-standard-detail-section
        :document-data="documentData"
        :page="page"
      />

      <div
        v-if="page.showTail && documentData.showLargeAmountResponsibles"
        class="dte-standard-gap"
      ></div>
      <dte-standard-footer-section
        v-if="page.showTail"
        :document-data="documentData"
      />

      <div
        v-if="page.showTail && appendixRows.length"
        class="dte-standard-gap"
      ></div>
      <dte-standard-data-table-section
        v-if="page.showTail && appendixRows.length"
        :document-data="documentData"
        title="Apéndice"
        :headers="['Campo', 'Etiqueta', 'Valor']"
        :rows="appendixRows"
      />

      <GuaranteePrintBlock
        v-if="page.showTail && documentData.showGuaranteeInline && documentData.guaranteeHtml"
        :html="documentData.guaranteeHtml"
        :business-id="guaranteeBusinessId"
        :branch-id="guaranteeBranchId"
        guarantee-type="COMPROBANTE"
        font-size="11px"
      />

      <div class="dte-sheet__page-number">
        Pagina {{ displayPageNumber(page.number) }} de {{ totalPageCount }}
      </div>
    </article>
    <article
      class="dte-sheet dte-sheet--standard"
      v-if="showGuaranteePage"
    >
      <div class="dte-standard-gap"></div>
      <GuaranteePrintBlock
        :business-id="guaranteeBusinessId"
        :branch-id="guaranteeBranchId"
        guarantee-type="COMPROBANTE"
        font-size="11px"
      />
      <div class="dte-sheet__page-number">
        Pagina {{ totalPageCount }} de {{ totalPageCount }}
      </div>
    </article>
  </div>
</template>

<script>
import DteStandardDataTableSection from "../sections/DteStandardDataTableSection.vue";
import DteStandardDetailSection from "../sections/DteStandardDetailSection.vue";
import DteStandardFooterSection from "../sections/DteStandardFooterSection.vue";
import DteFullPageBannerSheet from "../sections/DteFullPageBannerSheet.vue";
import DteStandardHeaderSection from "../sections/DteStandardHeaderSection.vue";
import DteStandardRecipientSection from "../sections/DteStandardRecipientSection.vue";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
  name: "PrintPosDteLetterStandardLayout",
  components: {
    DteFullPageBannerSheet,
    DteStandardDataTableSection,
    DteStandardDetailSection,
    DteStandardFooterSection,
    DteStandardHeaderSection,
    DteStandardRecipientSection,
    GuaranteePrintBlock,
  },
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    pages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    appendixRows() {
      const rows = Array.isArray(this.documentData.appendices)
        ? this.documentData.appendices
        : [];

      return rows.map((row) => [
        row.campo,
        row.etiqueta,
        row.valor,
      ]);
    },
    relatedRows() {
      return this.documentData.relatedDocuments.map((item) => [
        item.typeLabel,
        item.number,
        item.date,
      ]);
    },
    associatedRows() {
      return this.documentData.associatedDocuments.map((item) => [
        item.typeLabel,
        item.number,
        item.date,
      ]);
    },
    showFullPageBanner() {
      return Boolean(this.documentData.showFullPageBanner);
    },
    totalPageCount() {
      return this.pages.length + (this.showFullPageBanner ? 1 : 0) + (this.showGuaranteePage ? 1 : 0);
    },
    showGuaranteePage() {
      return Boolean(this.documentData.guaranteeHtml) && !this.documentData.showGuaranteeInline;
    },
    guaranteeBusinessId() {
      return (
        this.documentData?.rawData?.branch?.ID_Business ||
        JSON.parse(localStorage.getItem("user"))?.businessid ||
        null
      );
    },
    guaranteeBranchId() {
      return (
        this.documentData?.rawData?.branch?.ID_Branch ||
        JSON.parse(localStorage.getItem("branch"))?.ID_Branch ||
        null
      );
    },
  },
  methods: {
    displayPageNumber(pageNumber) {
      return pageNumber + (this.showFullPageBanner ? 1 : 0);
    },
    getPageElements() {
      return Array.from(this.$el.querySelectorAll(".dte-sheet"));
    },
  },
};
</script>
